<template>
<nav class="nav_center2" style="padding: 0; background: cadetblue">
    <ul class="" style="list-style: none">
        <li :class="{ topmenuactive: activeTab === 'HeThongCNTT' }" @click="changeTab('HeThongCNTT')">
            <a id="urlHeThongCNTT" href="vi/chuongtrinhtaitroxathidiem#quangtri/hethongcntt" style="color: white;">
                {{ currentLanguage.header_text_hethongCNTT15 }} </a>
        </li>
        <li :class="{ topmenuactive: activeTab === 'Xadiensanh' }" @click="changeTab('Xadiensanh')">
            <a id="urlXadiensanh" href="vi/chuongtrinhtaitroxathidiem#quangtri/xadiensanh" style="color: white;"> {{ currentLanguage.header_text_DienSanh }}</a>
        </li>

        <li :class="{ topmenuactive: activeTab === 'Xamythuy' }" @click="changeTab('Xamythuy')">
            <a id="urlXamythuy" href="vi/chuongtrinhtaitroxathidiem#quangtri/xamythuy" style="color: white;">{{ currentLanguage.header_text_MyThuy }}</a>
        </li>
        <li :class="{ topmenuactive: activeTab === 'Xahailang' }" @click="changeTab('Xahailang')">
            <a id="urlXahailang" href="vi/chuongtrinhtaitroxathidiem#quangtri/xahailang" style="color: white;"> {{ currentLanguage.header_text_HaiLang }}</a>
        </li>
        <li :class="{ topmenuactive: activeTab === 'Xanamhailang' }" @click="changeTab('Xanamhailang')">
            <a id="urlXanamhailang" href="vi/chuongtrinhtaitroxathidiem#quangtri/xanamhailang" style="color: white;"> {{ currentLanguage.header_text_NamHaiLang }}</a>
        </li>
        <li :class="{ topmenuactive: activeTab === 'Xavinhdinh' }" @click="changeTab('Xavinhdinh')">
            <a id="urlXavinhdinh" href="vi/chuongtrinhtaitroxathidiem#quangtri/xavinhdinh" style="color: white;"> {{ currentLanguage.header_text_VinhDinh }}</a>
        </li>
        <li :class="{ topmenuactive: activeTab === 'Xatrieuphong' }" @click="changeTab('Xatrieuphong')">
            <a id="urlXatrieuphong" href="vi/chuongtrinhtaitroxathidiem#quangtri/xatrieuphong" style="color: white;"> {{ currentLanguage.header_text_TrieuPhong }}</a>
        </li>
        <li :class="{ topmenuactive: activeTab === 'Xaaitu' }" @click="changeTab('Xaaitu')">
            <a id="urlXaaitu" href="vi/chuongtrinhtaitroxathidiem#quangtri/xaaitu" style="color: white;"> {{ currentLanguage.header_text_AiTu }}</a>
        </li>

        <li :class="{ topmenuactive: activeTab === 'Xatrieubinh' }" @click="changeTab('Xatrieubinh')">
            <a id="urlXatrieubinh" href="vi/chuongtrinhtaitroxathidiem#quangtri/xatrieubinh" style="color: white;"> {{ currentLanguage.header_text_TrieuBinh }}</a>
        </li>

        <li :class="{ topmenuactive: activeTab === 'Xatrieuco' }" @click="changeTab('Xatrieuco')">
            <a id="urlXatrieuco" href="vi/chuongtrinhtaitroxathidiem#quangtri/xatrieuco" style="color: white;"> {{ currentLanguage.header_text_TrieuCo }}</a>
        </li>

        <li :class="{ topmenuactive: activeTab === 'Xanamcuaviet' }" @click="changeTab('Xanamcuaviet')">
            <a id="urlXanamcuaviet" href="vi/chuongtrinhtaitroxathidiem#quangtri/xanamcuaviet" style="color: white;"> {{ currentLanguage.header_text_NamCuaViet }}</a>
        </li>
        <li :class="{ topmenuactive: activeTab === 'Xacuaviet' }" @click="changeTab('Xacuaviet')">
            <a id="urlXacuaviet" href="vi/chuongtrinhtaitroxathidiem#quangtri/xacuaviet" style="color: white;"> {{ currentLanguage.header_text_CuaViet }}</a>
        </li>

        <li :class="{ topmenuactive: activeTab === 'Xacuatung' }" @click="changeTab('Xacuatung')">
            <a id="urlXacuatung" href="vi/chuongtrinhtaitroxathidiem#quangtri/xacuatung" style="color: white;">{{ currentLanguage.header_text_CuaTung }}</a>
        </li>

        <li :class="{ topmenuactive: activeTab === 'Xabenhai' }" @click="changeTab('Xabenhai')">
            <a id="urlXabenhai" href="vi/chuongtrinhtaitroxathidiem#quangtri/xabenhai" style="color: white;"> {{ currentLanguage.header_text_BenHai }}</a>
        </li>

        <li :class="{ topmenuactive: activeTab === 'Xavinhlinh' }" @click="changeTab('Xavinhlinh')">
            <a id="urlXavinhlinh" href="vi/chuongtrinhtaitroxathidiem#quangtri/xavinhlinh" style="color: white;"> {{ currentLanguage.header_text_VinhLinh }}</a>
        </li>

        <li :class="{ topmenuactive: activeTab === 'Xavinhhoang' }" @click="changeTab('Xavinhhoang')">
            <a id="urlXavinhhoang" href="vi/chuongtrinhtaitroxathidiem#quangtri/xavinhhoang" style="color: white;"> {{ currentLanguage.header_text_VinhHoang }}</a>
        </li>
        <li :class="{ topmenuactive: activeTab === 'Xavinhthuy' }" @click="changeTab('Xavinhthuy')">
            <a id="urlXavinhthuy" href="vi/chuongtrinhtaitroxathidiem#quangtri/xavinhthuy" style="color: white;"> {{ currentLanguage.header_text_VinhThuy }}</a>
        </li>
        <li :class="{ topmenuactive: activeTab === 'Xabenquan' }" @click="changeTab('Xabenquan')">
            <a id="urlXabenquan" href="vi/chuongtrinhtaitroxathidiem#quangtri/xabenquan" style="color: white;"> {{ currentLanguage.header_text_BenQuan }}</a>
        </li>
        <li :class="{ topmenuactive: activeTab === 'Xatanmy' }" @click="changeTab('Xatanmy')">
            <a id="urlXatanmy" href="vi/chuongtrinhtaitroxathidiem#quangtri/xatanmy" style="color: white;"> {{ currentLanguage.header_text_TanMy }}</a>
        </li>
        <li :class="{ topmenuactive: activeTab === 'Xagiolinh' }" @click="changeTab('Xagiolinh')">
            <a id="urlXagiolinh" href="vi/chuongtrinhtaitroxathidiem#quangtri/xagiolinh" style="color: white;"> {{ currentLanguage.header_text_GioLinh }}</a>
        </li>
        <li :class="{ topmenuactive: activeTab === 'Xasenngu' }" @click="changeTab('Xasenngu')">
            <a id="urlXasenngu" href="vi/chuongtrinhtaitroxathidiem#quangtri/xasenngu" style="color: white;"> {{ currentLanguage.header_text_SenNgu }}</a>
        </li>
        <li :class="{ topmenuactive: activeTab === 'Xacamlo' }" @click="changeTab('Xacamlo')">
            <a id="urlCamlo" href="vi/chuongtrinhtaitroxathidiem#quangtri/xacamlo" style="color: white;"> {{ currentLanguage.header_text_CamLo }}</a>
        </li>
        <li :class="{ topmenuactive: activeTab === 'Xahieugiang' }" @click="changeTab('Xahieugiang')">
            <a id="urlHieugiang" href="vi/chuongtrinhtaitroxathidiem#quangtri/xahieugiang" style="color: white;"> {{ currentLanguage.header_text_HieuGiang }}</a>
        </li>
        <li :class="{ topmenuactive: activeTab === 'Xacontien' }" @click="changeTab('Xacontien')">
            <a id="urlContien" href="vi/chuongtrinhtaitroxathidiem#quangtri/xacontien" style="color: white;"> {{ currentLanguage.header_text_ConTien }}</a>
        </li>
        <li :class="{ topmenuactive: activeTab === 'Phuongquangtri' }" @click="changeTab('Phuongquangtri')">
            <a id="urlPhuongquangtri" href="vi/chuongtrinhtaitroxathidiem#quangtri/phuongquangtri" style="color: white;"> {{ currentLanguage.header_text_PhuongQuangTri }}</a>
        </li>
    </ul>
</nav>
<div class="wrapper row3 ">
    <main class="hoc container-fluid clear bv p-0">
       
                <div v-if="showHeThongCNTT" class="padding-top15">
                    <div class="title-bai-viet" v-html="titleHtmlHeThongCNTT"></div>
                    <div v-html="contentHtmlHeThongCNTT"></div>
                </div>
                <!-- Xadiensanh -->
                <div v-if="showXanamhailang" class="padding-top15">
                    <div class="title-bai-viet" v-html="titleHtmlXanamhailang"></div>
                    <div v-html="contentHtmlXanamhailang"></div>
                </div>
                <div v-if="showXamythuy" class="padding-top15">
                    <div class="title-bai-viet" v-html="titleHtmlXamythuy"></div>
                    <div v-html="contentHtmlXamythuy"></div>
                </div>
                <div v-if="showXavinhdinh" class="padding-top15">
                    <div class="title-bai-viet" v-html="titleHtmlXavinhdinh"></div>
                    <div v-html="contentHtmlXavinhdinh"></div>
                </div>
                <div v-if="showXaaitu" class="padding-top15">
                    <div class="title-bai-viet" v-html="titleHtmlXaaitu"></div>
                    <div v-html="contentHtmlXaaitu"></div>
                </div>
                <div v-if="showXatrieuphong" class="padding-top15">
                    <div class="title-bai-viet" v-html="titleHtmlXatrieuphong"></div>
                    <div v-html="contentHtmlXatrieuphong"></div>
                </div>
                <div v-if="showXahailang" class="padding-top15">
                    <div class="title-bai-viet" v-html="titleHtmlXahailang"></div>
                    <div v-html="contentHtmlXahailang"></div>
                </div>
                <div v-if="showXatrieubinh" class="padding-top15">
                    <div class="title-bai-viet" v-html="titleHtmlXatrieubinh"></div>
                    <div v-html="contentHtmlXatrieubinh"></div>
                </div>
                <div v-if="showXadiensanh" class="padding-top15">
                    <div class="title-bai-viet" v-html="titleHtmlXadiensanh"></div>
                    <div v-html="contentHtmlXadiensanh"></div>
                </div>

                <div v-if="showXatrieuco" class="padding-top15">
                    <div class="title-bai-viet" v-html="titleHtmlXatrieuco"></div>
                    <div v-html="contentHtmlXatrieuco"></div>
                </div>
                <div v-if="showXanamcuaviet" class="padding-top15">
                    <div class="title-bai-viet" v-html="titleHtmlXanamcuaviet"></div>
                    <div v-html="contentHtmlXanamcuaviet"></div>
                </div>
                <div v-if="showXacuaviet" class="padding-top15">
                    <div class="title-bai-viet" v-html="titleHtmlXacuaviet"></div>
                    <div v-html="contentHtmlXacuaviet"></div>
                </div>

                <div v-if="showXacuatung" class="padding-top15">
                    <div class="title-bai-viet" v-html="titleHtmlXacuatung"></div>
                    <div v-html="contentHtmlXacuatung"></div>
                </div>

                <div v-if="showXabenhai" class="padding-top15">
                    <div class="title-bai-viet" v-html="titleHtmlXabenhai"></div>
                    <div v-html="contentHtmlXabenhai"></div>
                </div>

                <div v-if="showXavinhlinh" class="padding-top15">
                    <div class="title-bai-viet" v-html="titleHtmlXavinhlinh"></div>
                    <div v-html="contentHtmlXavinhlinh"></div>
                </div>

                <div v-if="showXavinhhoang" class="padding-top15">
                    <div class="title-bai-viet" v-html="titleHtmlXavinhhoang"></div>
                    <div v-html="contentHtmlXavinhhoang"></div>
                </div>

                <div v-if="showXavinhthuy" class="padding-top15">
                    <div class="title-bai-viet" v-html="titleHtmlXavinhthuy"></div>
                    <div v-html="contentHtmlXavinhthuy"></div>
                </div>
                <div v-if="showXabenquan" class="padding-top15">
                    <div class="title-bai-viet" v-html="titleHtmlXabenquan"></div>
                    <div v-html="contentHtmlXabenquan"></div>
                </div>
                <div v-if="showXagiolinh" class="padding-top15">
                    <div class="title-bai-viet" v-html="titleHtmlXagiolinh"></div>
                    <div v-html="contentHtmlXagiolinh"></div>
                </div>
                <div v-if="showXasenngu" class="padding-top15">
                    <div class="title-bai-viet" v-html="titleHtmlXasenngu"></div>
                    <div v-html="contentHtmlXasenngu"></div>
                </div>
                <div v-if="showPhuongquangtri" class="padding-top15">
                    <div class="title-bai-viet" v-html="titleHtmlPhuongquangtri"></div>
                    <div v-html="contentHtmlPhuongquangtri"></div>
                </div>
                <div v-if="showXatanmy" class="padding-top15">
                    <div class="title-bai-viet" v-html="titleHtmlXatanmy"></div>
                    <div v-html="contentHtmlXatanmy"></div>
                </div>
                <div v-if="showXacamlo" class="padding-top15">
                    <div class="title-bai-viet" v-html="titleHtmlXacamlo"></div>
                    <div v-html="contentHtmlXacamlo"></div>
                    </div>
                <div v-if="showXahieugiang" class="padding-top15">
                    <div class="title-bai-viet" v-html="titleHtmlXahieugiang"></div>
                    <div v-html="contentHtmlXahieugiang"></div>
                </div>
                <div v-if="showXacontien" class="padding-top15">
                    <div class="title-bai-viet" v-html="titleHtmlXacontien"></div>
                    <div v-html="contentHtmlXacontien"></div>
                </div>
        
    </main>
</div>
</template>

<script>
import {
    languages
} from "@/components/languages";
import {
    apiChiTietBaiViet
} from "@/components/listService";
import axios from "axios";

export default {
    components: {

    },
    data() {
        return {
            activeTab: 'Xadiensanh',

            currentLanguage: languages.vi,
            lang: "",
            base64: "",
            base64Title: "",
            showHeThongCNTT: false,
            titleHtmlHeThongCNTT: "",
            contentHtmlHeThongCNTT: "",
            showXanamhailang: false,
            showXamythuy: false,
            showXavinhdinh: false,
            showXaaitu: false,
            showXatrieuphong: false,
            showXahailang: false,
            showXatrieubinh: false,
            showXadiensanh: false,
            showXatrieuco: false,
            showXanamcuaviet: false,
            showUngDungAI: false,
            showXavinhthuy: false,
            showXabenquan: false,
            showXagiolinh: false,
            showXasenngu: false,
            showPhuongquangtri: false,
            showXatanmy: false,
            showXacamlo: false,
            showXahieugiang: false,
            showXacontien: false,

            titleHtmlXavinhthuy: "",
            contentHtmlXavinhthuy: "",
            titleHtmlXabenquan: "",
            contentHtmlXabenquan: "",
            titleHtmlXagiolinh: "",
            contentHtmlXagiolinh: "",
            titleHtmlXasenngu: "",
            contentHtmlXasenngu: "",
            titleHtmlPhuongquangtri: "",
            contentHtmlPhuongquangtri: "",

            titleHtmlAITaiLopHoc: "",
            contentHtmlAITaiLopHoc: "",
            titleHtml: "",
            contentHtml: "",
            titleHtmlTruongTaiTro: "",
            contentHtmlTruongTaiTro: "",
            titleHtmlTH: "",
            contentHtmlTH: "",
            titleHtmlTHCS: "",
            contentHtmlTHCS: "",
            titleHtmlTHPT: "",
            contentHtmlTHPT: "",
            titleHtmlLienHe: "",
            contentHtmlLienHe: "",
            titleHtmlLienCap: "",
            contentHtmlLienCap: "",
            titleHtmlXatrieuco: "",
            contentHtmlXatrieuco: "",
            titleHtmlXanamhailang: "",
            contentHtmlXanamhailang: "",
            titleHtmlXanamcuaviet: "",
            contentHtmlXanamcuaviet: "",

            titleHtmlXadiensanh: "",
            titleHtmlXamythuy: "",
            titleHtmlXavinhdinh: "",
            titleHtmlXaaitu: "",
            titleHtmlXatrieuphong: "",
            titleHtmlXahailang: "",
            titleHtmlXatrieubinh: "",
            titleHtmlXatanmy: "",
            contentHtmlXatanmy: "",

            contentHtmlXadiensanh: "",
            contentHtmlXamythuy: "",
            contentHtmlXaaitu: "",
            contentHtmlXavinhdinh: "",
            contentHtmlXatrieuphong: "",
            contentHtmlXahailang: "",
            contentHtmlXatrieubinh: "",
            showXacuaviet: false,
            showXacuatung: false,
            showXabenhai: false,
            showXavinhlinh: false,
            showXavinhhoang: false,

            titleHtmlXacuaviet: "",
            contentHtmlXacuaviet: "",
            titleHtmlXacuatung: "",
            contentHtmlXacuatung: "",
            titleHtmlXabenhai: "",
            contentHtmlXabenhai: "",
            titleHtmlXavinhlinh: "",
            contentHtmlXavinhlinh: "",
            titleHtmlXavinhhoang: "",
            contentHtmlXavinhhoang: "",
            titleHtmlXacamlo: "",
            contentHtmlXacamlo: "",
            titleHtmlXahieugiang: "",
            contentHtmlXahieugiang: "",
            titleHtmlXacontien: "",
            contentHtmlXacontien: "",
        };
    },
    mounted() {
        if (window.innerWidth <= 768) {
            this.isMenuVisible = false;
        } else {
            this.isMenuVisible = true;
        }
        if (!this.hasMounted) {
            this.hasMounted = true;
            this.lang = localStorage.getItem("languages") || "vi";
            // this.performPostRequest("17552293104916nT35", "Xadiensanh", this.lang);
            document.getElementById("urlHeThongCNTT").setAttribute(
                "href",
                this.lang + "/chuongtrinhtaitroxathidiem#quangtri/hethongcntt"
            );
            document.getElementById("urlXadiensanh").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#quangtri/xadiensanh");
            document.getElementById("urlXavinhdinh").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#quangtri/xavinhdinh");
            document.getElementById("urlXamythuy").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#quangtri/xamythuy");
            document.getElementById("urlXanamhailang").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#quangtri/xanamhailang");
            document.getElementById("urlXahailang").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#quangtri/xahailang");
            document.getElementById("urlXatrieubinh").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#quangtri/xatrieubinh");
            document.getElementById("urlXatrieuphong").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#quangtri/xatrieuphong");
            document.getElementById("urlXaaitu").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#quangtri/xaaitu/");
            document.getElementById("urlXatrieuco").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#quangtri/xatrieuco");
            document.getElementById("urlXanamcuaviet").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#quangtri/xanamcuaviet");
            document.getElementById("urlXavinhthuy").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#quangtri/xavinhthuy");
            document.getElementById("urlXabenquan").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#quangtri/xabenquan");
            document.getElementById("urlXagiolinh").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#quangtri/xagiolinh");
            document.getElementById("urlXasenngu").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#quangtri/xasenngu");
            document.getElementById("urlPhuongquangtri").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#quangtri/phuongquangtri");
            document.getElementById("urlXacuaviet").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#quangtri/xacuaviet");
            document.getElementById("urlXacuatung").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#quangtri/xacuatung");
            document.getElementById("urlXabenhai").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#quangtri/xabenhai");
            document.getElementById("urlXavinhlinh").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#quangtri/xavinhlinh");
            document.getElementById("urlXavinhhoang").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#quangtri/xavinhhoang");
            document.getElementById("urlXatanmy").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#quangtri/xatanmy");
            document.getElementById("urlCamlo").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#quangtri/xacamlo");
            document.getElementById("urlHieugiang").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#quangtri/xahieugiang");
            document.getElementById("urlContien").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#quangtri/xacontien");

            let fragmentTab = window.location.hash.substring(1);
            if (fragmentTab.endsWith("/")) {
                fragmentTab = fragmentTab.slice(0, -1);
            }
            console.log("fragmentTab " + fragmentTab);

            if (fragmentTab === "quangtri/xadiensanh") {
                this.changeTab("Xadiensanh");
            } else if (fragmentTab === "quangtri/xavinhdinh") {
                this.changeTab("Xavinhdinh");
            } else if (fragmentTab === "quangtri/xamythuy") {
                this.changeTab("Xamythuy");
            } else if (fragmentTab === "quangtri/xanamhailang") {
                this.changeTab("Xanamhailang");
            } else if (fragmentTab === "quangtri/xaaitu") {
                this.changeTab("Xaaitu");
            } else if (fragmentTab === "quangtri/xatrieuphong") {
                this.changeTab("Xatrieuphong");
            } else if (fragmentTab === "quangtri/xahailang") {
                this.changeTab("Xahailang");
            } else if (fragmentTab === "quangtri/xatrieubinh") {
                this.changeTab("Xatrieubinh");
            } else if (fragmentTab === "quangtri/xatrieuco") {
                this.changeTab("Xatrieuco");
            } else if (fragmentTab === "quangtri/xanamcuaviet") {
                this.changeTab("Xanamcuaviet");
            } else if (fragmentTab === "quangtri/xavinhthuy") {
                this.changeTab("Xavinhthuy")
            } else if (fragmentTab === "quangtri/xabenquan") {
                this.changeTab("Xabenquan");
            } else if (fragmentTab === "quangtri/xagiolinh") {
                this.changeTab("Xagiolinh");
            } else if (fragmentTab === "quangtri/xasenngu") {
                this.changeTab("Xasenngu");
            } else if (fragmentTab === "quangtri/phuongquangtri") {
                this.changeTab("Phuongquangtri");
            } else if (fragmentTab === "quangtri/hethongcntt") {
                this.changeTab("HeThongCNTT");
            } else if (fragmentTab === "quangtri/xacuaviet") {
                this.changeTab("Xacuaviet");
            } else if (fragmentTab === "quangtri/xacuatung") {
                this.changeTab("Xacuatung");
            } else if (fragmentTab === "quangtri/xabenhai") {
                this.changeTab("Xabenhai");
            } else if (fragmentTab === "quangtri/xavinhlinh") {
                this.changeTab("Xavinhlinh");
            } else if (fragmentTab === "quangtri/xavinhhoang") {
                this.changeTab("Xavinhhoang");
            } else if (fragmentTab === "quangtri/xatanmy") {
                this.changeTab("Xatanmy");
            } else if (fragmentTab === "quangtri/xacamlo") {
                this.changeTab("Xacamlo");
            } else if (fragmentTab === "quangtri/xahieugiang") {
                this.changeTab("Xahieugiang");
            } else if (fragmentTab === "quangtri/xacontien") {
                this.changeTab("Xacontien");
            }
            
            else {
                // Nếu không phù hợp với bất kỳ tab nào, mặc định hiển thị tab gioiThieu
                this.changeTab("HeThongCNTT");
            }
        }
    },
    created() {
        const savedLanguage = localStorage.getItem("languages");
        if (savedLanguage && languages[savedLanguage]) {
            this.currentLanguage = languages[savedLanguage];
        }
    },
    methods: {
        changeLanguage(lang) {
            this.currentLanguage = languages[lang];
            localStorage.setItem("languages", lang);
            window.location.reload();
        },

        async performPostRequest(id, section) {
            this.lang = localStorage.getItem("languages") || "vi";

            try {
                // Thực hiện POST request
                const response = await axios.post(apiChiTietBaiViet, {
                    id: id,
                    langId: "0",
                });
                if (this.lang === "vi") {
                    this.base64 = response.data.result.content_vi;
                    this.base64Title = response.data.result.title_vi;
                } else if (this.lang === "en") {
                    this.base64 = response.data.result.content_en;
                    this.base64Title = response.data.result.title_en;
                } else if (this.lang === "cn") {
                    this.base64 = response.data.result.content_cn;
                    this.base64Title = response.data.result.title_cn;
                } else if (this.lang === "kr") {
                    this.base64 = response.data.result.content_kr;
                    this.base64Title = response.data.result.title_kr;
                }

                var title = atob(this.base64Title);
                var decodedString = atob(this.base64);

                // Store separately for each section
                if (section === "Xanamhailang") {
                    this.titleHtmlXanamhailang = decodeURIComponent(escape(title));
                    this.contentHtmlXanamhailang = decodeURIComponent(escape(decodedString));
                } else if (section === "Xamythuy") {
                    this.titleHtmlXamythuy = decodeURIComponent(escape(title));
                    this.contentHtmlXamythuy = decodeURIComponent(escape(decodedString));
                } else if (section === "Xavinhdinh") {
                    this.titleHtmlXavinhdinh = decodeURIComponent(escape(title));
                    this.contentHtmlXavinhdinh = decodeURIComponent(escape(decodedString));
                } else if (section === "Xaaitu") {
                    this.titleHtmlXaaitu = decodeURIComponent(escape(title));
                    this.contentHtmlXaaitu = decodeURIComponent(escape(decodedString));
                } else if (section === "Xatrieuphong") {
                    this.titleHtmlXatrieuphong = decodeURIComponent(escape(title));
                    this.contentHtmlXatrieuphong = decodeURIComponent(escape(decodedString));
                } else if (section === "Xahailang") {
                    this.titleHtmlXahailang = decodeURIComponent(escape(title));
                    this.contentHtmlXahailang = decodeURIComponent(escape(decodedString));
                } else if (section === "Xatrieubinh") {
                    this.titleHtmlXatrieubinh = decodeURIComponent(escape(title));
                    this.contentHtmlXatrieubinh = decodeURIComponent(escape(decodedString));
                } else if (section === "Xadiensanh") {
                    this.titleHtmlXadiensanh = decodeURIComponent(escape(title));
                    this.contentHtmlXadiensanh = decodeURIComponent(escape(decodedString));
                } else if (section === "Xatrieuco") {
                    this.titleHtmlXatrieuco = decodeURIComponent(escape(title));
                    this.contentHtmlXatrieuco = decodeURIComponent(escape(decodedString));
                } else if (section === "Xanamcuaviet") {
                    this.titleHtmlXanamcuaviet = decodeURIComponent(escape(title));
                    this.contentHtmlXanamcuaviet = decodeURIComponent(escape(decodedString));
                } else if (section === "Xacuaviet") {
                    this.titleHtmlXacuaviet = decodeURIComponent(escape(title));
                    this.contentHtmlXacuaviet = decodeURIComponent(escape(decodedString));
                } else if (section === "Xacuatung") {
                    this.titleHtmlXacuatung = decodeURIComponent(escape(title));
                    this.contentHtmlXacuatung = decodeURIComponent(escape(decodedString));
                } else if (section === "Xabenhai") {
                    this.titleHtmlXabenhai = decodeURIComponent(escape(title));
                    this.contentHtmlXabenhai = decodeURIComponent(escape(decodedString));
                } else if (section === "Xavinhlinh") {
                    this.titleHtmlXavinhlinh = decodeURIComponent(escape(title));
                    this.contentHtmlXavinhlinh = decodeURIComponent(escape(decodedString));
                } else if (section === "Xavinhhoang") {
                    this.titleHtmlXavinhhoang = decodeURIComponent(escape(title));
                    this.contentHtmlXavinhhoang = decodeURIComponent(escape(decodedString));
                } else if (section === "Xavinhthuy") {
                    this.titleHtmlXavinhthuy = decodeURIComponent(escape(title));
                    this.contentHtmlXavinhthuy = decodeURIComponent(escape(decodedString));
                } else if (section === "Xabenquan") {
                    this.titleHtmlXabenquan = decodeURIComponent(escape(title));
                    this.contentHtmlXabenquan = decodeURIComponent(escape(decodedString));
                } else if (section === "Xagiolinh") {
                    this.titleHtmlXagiolinh = decodeURIComponent(escape(title));
                    this.contentHtmlXagiolinh = decodeURIComponent(escape(decodedString));
                } else if (section === "Xasenngu") {
                    this.titleHtmlXasenngu = decodeURIComponent(escape(title));
                    this.contentHtmlXasenngu = decodeURIComponent(escape(decodedString));
                } else if (section === "Phuongquangtri") {
                    this.titleHtmlPhuongquangtri = decodeURIComponent(escape(title));
                    this.contentHtmlPhuongquangtri = decodeURIComponent(escape(decodedString));
                } else if (section === "HeThongCNTT") {
                    this.titleHtmlHeThongCNTT = decodeURIComponent(escape(title));
                    this.contentHtmlHeThongCNTT = decodeURIComponent(escape(decodedString));
                } else if (section === "Xatanmy") {
                    this.titleHtmlXatanmy = decodeURIComponent(escape(title));
                    this.contentHtmlXatanmy = decodeURIComponent(escape(decodedString));
                } else if (section === "Xacamlo") {
                    this.titleHtmlXacamlo = decodeURIComponent(escape(title));
                    this.contentHtmlXacamlo = decodeURIComponent(escape(decodedString));
                } else if (section === "Xahieugiang") {
                    this.titleHtmlXahieugiang = decodeURIComponent(escape(title));
                    this.contentHtmlXahieugiang = decodeURIComponent(escape(decodedString));
                } else if (section === "Xacontien") {
                    this.titleHtmlXacontien = decodeURIComponent(escape(title));
                    this.contentHtmlXacontien = decodeURIComponent(escape(decodedString));
                }
            } catch (error) {
                console.error("Error:", error);
            }
        },
        changeTab(tab) {
            //   if (window.innerWidth <= 768) {
            //     this.isMenuVisible = false;
            //   }
            console.log("Changing to tab:", tab);
            
            this.lang = localStorage.getItem("languages");

            const tabStates = {

                Xanamhailang: false,
                Xamythuy: false,
                Xavinhdinh: false,
                Xaaitu: false,
                ungDungAI: false,
                Xadiensanh: false,
                Xatrieuphong: false,
                Xahailang: false,
                Xatrieubinh: false,
                Xatrieuco: false,
                Xanamcuaviet: false,
                Xacuaviet: false,
                Xacuatung: false,
                Xabenhai: false,
                Xavinhlinh: false,
                Xavinhhoang: false,
                Xavinhthuy: false,
                Xabenquan: false,
                Xagiolinh: false,
                Xasenngu: false,
                Phuongquangtri: false,
                HeThongCNTT: false,
                Xatanmy: false,
                Xacamlo: false,
                Xahieugiang: false,
                Xacontien: false,

            };

            this.performPostRequest(this.getPostId(tab), tab, this.lang);

            tabStates[tab] = true;
            this.activeTab = tab;
            this.showXanamhailang = tabStates.Xanamhailang;
            this.showXamythuy = tabStates.Xamythuy;
            this.showXavinhdinh = tabStates.Xavinhdinh;
            this.showXaaitu = tabStates.Xaaitu;
            this.showXatrieuphong = tabStates.Xatrieuphong;
            this.showXahailang = tabStates.Xahailang;
            this.showXatrieubinh = tabStates.Xatrieubinh;
            this.showXadiensanh = tabStates.Xadiensanh;
            this.showXatrieuco = tabStates.Xatrieuco;
            this.showXanamcuaviet = tabStates.Xanamcuaviet;
            this.showXacuaviet = tabStates.Xacuaviet;
            this.showXacuatung = tabStates.Xacuatung;
            this.showXabenhai = tabStates.Xabenhai;
            this.showHeThongCNTT = tabStates.HeThongCNTT;

            this.showXavinhlinh = tabStates.Xavinhlinh;
            this.showXavinhhoang = tabStates.Xavinhhoang;
            this.showXavinhthuy = tabStates.Xavinhthuy;
            this.showXabenquan = tabStates.Xabenquan;
            this.showXagiolinh = tabStates.Xagiolinh;
            this.showXasenngu = tabStates.Xasenngu;
            this.showPhuongquangtri = tabStates.Phuongquangtri;
            this.showXatanmy = tabStates.Xatanmy;
            this.showXacamlo = tabStates.Xacamlo;
            this.showXahieugiang = tabStates.Xahieugiang;
            this.showXacontien = tabStates.Xacontien;
        },
        getPostId(tab) {
            // Sử dụng một đối tượng để ánh xạ tab với id của bài viết tương ứng
            const postIdMap = {

                Xanamhailang: "1757647238922CZUfM",
                Xamythuy: "1757647121513KIWj2",
                Xavinhdinh: "1757647269085qGt3O",
                Xaaitu: "1757647362820XCaCL",
                Xatrieuphong: "1757647329746s1lMp",
                Xahailang: "1757647213359NIB77",
                Xatrieubinh: "1757647391282aHBD8",
                Xadiensanh: "17552293104916nT35",
                Xatrieuco: "17576474241370edof",
                Xanamcuaviet: "1757647457038UD8I1",
                Xacuaviet: "175764748542456DjT",
                Xacuatung: "1757647517260eI5sz",
                Xabenhai: "1757647547063TKR82",
                Xavinhlinh: "1757647577236mko3H",
                HeThongCNTT: "1757136728480BLQbI",
                Xavinhhoang: "1757647610044Eo1IU",
                Xavinhthuy: "1757647639754f1qnI",
                Xabenquan: "1757647671435bNaDK",
                Xagiolinh: "1757647734715n02UF",
                Xasenngu: "1757647764880NmY69",
                Phuongquangtri: "1757647794716YDu5t",
                Xatanmy: "1757647703732TJjSb",
                Xacamlo: "1758678768934wItgD",
                Xahieugiang: "1758678795879lUOr0",
                Xacontien: "1758678832652dgHmA",
                
            };

            return postIdMap[tab];
        },
    },
};
</script>

<style scoped>
nav ul li a {
    font-size: 13px;
}

</style>
